import * as React from "react";
import FollowComponent from "./FollowComponent";
import {connect} from "react-redux";
import {toggleShopFollow, toggleUserFollow} from "../../_data/middlewares";
import {ResourceType} from "../../_helpers/data";
import User from "../../_data/models/User";
import Shop from "../../_data/models/Shop";
import {currentUserIdSelector} from "../../user/selectors";

interface Props {
    model: User | Shop;
    className?: string;
}
const mapStateToProps = (state, props: Props) => {
    return {
        model: props.model,
        className: props.className,
        currentUserID: currentUserIdSelector(state)
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        toggleFollow: (id: number, follower_id: number, is_followed: boolean, model_type: string) => {
            if (model_type === ResourceType.user) {
                dispatch(toggleUserFollow(id, follower_id, is_followed));
            }
            else if (model_type === ResourceType.shop) {
                dispatch(toggleShopFollow(id, follower_id, is_followed));
            }
        }
    }
};

const FollowContainer = connect(mapStateToProps, mapDispatchToProps)(FollowComponent);
export default FollowContainer;


// WEBPACK FOOTER //
// ./app/client/_widgets/follow/FollowContainer.tsx